import { useCallback, useState } from 'react';

/**
 * Chatbot显示数据流
 */
export default function useChatbotModel() {
  const [open, setOpen] = useState<boolean>(false);

  const openChatbot = useCallback(() => setOpen(true), []);

  const closeChatbot = useCallback(() => setOpen(false), []);

  return {
    chatbotOpen: open,
    openChatbot,
    closeChatbot,
  };
}
